<template>
    <v-row>
        <v-col v-for="detail in details" :key="detail.id" cols="12" class="">
            <v-card flat align="center" class="card dt-border">
                <v-row align="center" >
                    <v-col cols="12" class="card__column" md="8" style="">
                        <img
                        class="card__column__img"
                        width="40"
                        height="40"
                        :src="detail.country.flag"
                        />

                        <span class="mr-2">{{detail.name}}</span> 
                        <span class="mr-2">{{detail.country.cca2}}</span>
                        <span>{{ `(${detail.country.currencySymbol}${detail.cardMin} - ${detail.country.currencySymbol}${detail.cardMax})`}}</span>
                        <span class="ml-10"> Rate @ <span class="orange--text">{{ detail.rate}}</span></span>
                        <span class="ml-10 grey--text">{{ detail.type}} Card</span>
                    </v-col>
                    <v-col md="2">
                        <v-icon v-if="detail.status == active" color="green">
                            mdi-checkbox-marked-circle
                        </v-icon>
                        <v-icon v-if="detail.status == inactive" color="red">
                            mdi-close-circle
                        </v-icon>
                    </v-col>
                    <v-col v-if="can('can_manage_giftcards')" md="2">
                        <v-menu :close-on-content-click="true" bottom right>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" icon>
                                    <v-icon>
                                        mdi-dots-vertical
                                    </v-icon>
                                </v-btn>
                            </template>

                            <v-list>
                                <v-list-item link>
                                    <v-list-item-title v-if="detail.status == active" color="red" @click="editStatus(detail,inactive)" >Disable</v-list-item-title>
                                    <v-list-item-title v-if="detail.status == inactive" @click="editStatus(detail,active)" >Enable</v-list-item-title>
                                </v-list-item>
                                <v-list-item link>
                                    <!-- <v-list-item-title @click="deleteGiftcard(detail)">Delete
                                    </v-list-item-title> -->
                                    <deletegiftcard-modal @closeModal="closeModal" :details="detail" />
                                </v-list-item>
                                <v-list-item link>
                                    <v-list-item-title>
                                        <editgiftcard-modal @closeModal = "closeModal" :details = "detail" />
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item link>
                                    <v-list-item-title>
                                        <termsModal @closeModal = "closeModal" :terms="detail.terms" :id="detail.id"/>
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                        
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
// ============ IMPORT COMPONENTS =============
import EditgiftcardModal from './edit-giftcard-modal.vue'
import DeletegiftcardModal from './delete-giftcard-modal.vue'
import termsModal from './terms-modal.vue';

// ============= IMPORT SERVICES =============
import { StoresService } from "@/services";
import { StatusType } from "@/enums";

export default {
    props:{
        details:{
            type:Array,
            
        }
    },
    components:{
        EditgiftcardModal,
        DeletegiftcardModal,
        termsModal
    },
    data:() => ({
        active : StatusType.ACTIVE,
        inactive : StatusType.INACTIVE,
    }),
    mounted(){
       console.log('the su family: ', this.details);
    },
    methods: {
        
        async editStatus(index, status){
            try {
                const { data } = await StoresService.editGiftcard({
                    id : index.id,
                    status: status
                });
                if(status == this.active){
                this.$store.dispatch('toast', {
                message: `${index.name} Giftcard has been activated`,
                variant: 'success'
                })
            }
            if(status == this.inactive){
                this.$store.dispatch('toast', {
                message: `${index.name} Giftcard has been deactivated`,
                variant: 'success'
                })
            }
            console.log(data);
            this.$emit('reload')
            } catch (error) {
                console.log(error);
            }
        },
        async deleteGiftcard(index) {
            try {
                const { data } = await StoresService.deleteGiftcard({
                    id: index.id,
                });
                console.log(data);
                this.$emit('reload')
            } catch (error) {
                console.log(error);
            }
        },
        async closeModal(){
          this.$emit('reload');
      },
    }
}
</script>

<style lang="scss" scoped>
@import './styles.scss'
</style>